import { css } from '@emotion/react';

export const popoverMenuItemStyles = css({
  height: 'auto',
  minHeight: 'fit-content',
  width: '100%',
  padding: 0,
  ':last-child > div': { borderColor: 'transparent' },
});
